const googleScript = document.createElement('script');
googleScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-0J3SED2LJF';
googleScript.async = true;

const tagScript = document.createElement('script');
tagScript.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-0J3SED2LJF');
`;

document.body.append(googleScript);
document.body.append(tagScript);